<template>
    <v-layout column>
        <v-layout>
            <top-info-panel >
                <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
                    <h4>Zoek en filter uw assets</h4>
                    <p>Krijg een overzicht in uw a1sets en de status hiervan doormiddel van de zoekfunctie</p>
                </v-flex>
            </top-info-panel>
        </v-layout>
        <asset-overview @assetSelected="redirectToAsset"></asset-overview>
    </v-layout>
</template>
<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import TopInfoPanel from '../../components/global/TopInfoPanel'
    import VWidget from '../../components/global/VWidget'    
    import MapMixin from '../../plugins/mixins/MapMixin'
    import ColorMixin from '../../plugins/mixins/ColorMixin'
    import AssetOverview from "../../components/asset/AssetOverview";
    import "leaflet/dist/leaflet.css"

    export default {
        mixins:[ MapMixin, ColorMixin ],
        components: {    
            TopInfoPanel,
            AssetOverview            
        },        
        data(){
            return {          
                showEditDialog: false          
            }
        },
        methods:{
            redirectToAsset(asset)
            {
                 this.$router.push("/asset-details/" + asset.id);
            }
        }
        
    }
</script>
<style scoped>
    .status-circle{
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 3px solid rgba(255,255,255,0.4);
        background-color: grey;
        margin-right: 10px;
    }

    .asset-overview{
        display: flex;
        align-content: center;
        align-items: center;
    }

    .asset-overview-name{
        display: flex;
        align-items: center;
        align-content: center;
    }
</style>